import React, { useState } from "react";

export function useMappingStepper({ steps, save }: any) {
  const [currentStep, setCurrentStep] = useState(0);
  const [stepsState, setStepsState] = useState(steps);
  let previousStep: number;

  function changeStep(i: number, e: any = null) {
    if (e) e.preventDefault();

    if (i < 0 || i >= steps.length) save();

    if (i < steps.length) setCurrentStep(i);

    previousStep = currentStep;
    configureSteps();
  }

  function configureSteps() {
    if (previousStep === 1) {
      stepsState[0] = React.cloneElement(stepsState[0], { previousStep });
      setStepsState([...stepsState]);
    }
  }

  function validForm(e: any) {
    if (e) e.preventDefault();
  }

  return {
    currentStep,
    currentComponent: steps === undefined ? null : stepsState[currentStep],
    changeStep,
    isLastStep: currentStep + 1 === steps.length,
    isFirstStep: currentStep === 0,
    validForm,
  };
}
